export const REFERRALS_EVENTS = {
    SELECT_BANNER_REFERRALS_COPY_LINK: 'select_banner_referrals_copy_link',
    SELECT_BANNER_REFERRALS_TERMS_CONDITIONS: 'select_banner_referrals_t&c',
    SELECT_PARENTHOME_REFERRALS: 'select_parenthome_referrals',
    API_PARENTHOME_REFERRALS_SUCCESS: 'api_parenthome_referrals_success',
    API_PARENTHOME_REFERRALS_ERROR: 'api_parenthome_referrals_error',
    VIEW_REFERRALS_SECTION: 'view_referrals_section',
    SELECT_REFERRALS_SECTION_TERMS_CONDITIONS: 'select_referrals_section_t&c',
    SELECT_REFERRALS_SECTION_COPY_LINK: 'select_referrals_section_copy_link',
} as const;